import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import { global } from ":shared/app";
import { LockedAnchor } from ":src/components/overlays";
export default function Livestage(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("live_stage");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.toast.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Live Stage",
        idleIcon: <i class="i-bi:play-btn" />,
        activeIcon: <i class="i-bi:play-btn" />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
